import CryptoJS from "crypto-js";

const KEY = CryptoJS.enc.Utf8.parse("DFSW5SN7mkjM9RtNVldCRinIYnZR92EF");
const IV = CryptoJS.enc.Utf8.parse("KE1RTKZ6oxsFWgXA");

export function decryptConfig(encryptedText) {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(jsonString);
}
